<template>
  <div>
    <div class="mes-list flex-center">
      <div class="list-left">
        <p>修改绑定手机</p>
        <p>当前手机号码：{{ hideMobile }}</p>
      </div>
      <el-button
        type="text"
        @click="
          hasVerificationOldPhone = false
          phoneDialog = true
        "
      >
        修改
      </el-button>

      <!-- 修改绑定手机号的弹窗 -->
      <el-dialog
        title="修改绑定手机"
        :visible.sync="phoneDialog"
        width="50rem"
        :center="true"
        :before-close="clearPhoneDialog"
        class="dialog"
        :close-on-click-modal="false"
        :append-to-body="true"
      >
        <!-- 验证旧手机号 -->
        <template v-if="!hasVerificationOldPhone">
          <div key="old" class="phone-content old-phone-content">
            <p>为了您的账号安全，请验证身份。验证成功后进行下一步操作</p>
            <p>当前手机号为：{{ hideMobile }}</p>

            <el-form
              ref="smsForm"
              :model="smsCodeForm"
              :rules="smsCodeRules"
              :inline="true"
            >
              <el-form-item prop="smsCode">
                <el-input
                  v-model.trim="smsCodeForm.smsCode"
                  placeholder="请输入验证码"
                  @keyup.enter.native="updateMobileVerify"
                  @keydown.enter.native.prevent="() => {}"
                />
              </el-form-item>
              <el-form-item>
                <count-down-button
                  ref="countDownBtn"
                  :mobile="userMobile"
                  :template-code="templateCodeObj.changeMobile"
                  @click.native="$refs.countDownBtn.showDialog()"
                  @getSmsToken="data => (smsCodeForm.smsToken = data.token)"
                />
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="updateMobileVerify">
              下 一 步
            </el-button>
          </span>
        </template>

        <!-- 输入新手机号 -->
        <template v-else>
          <div key="new" class="phone-content new-phone-content">
            <el-form ref="phoneForm" :model="phoneForm" :rules="phoneRules">
              <el-form-item prop="mobile">
                <el-input
                  v-model.trim="phoneForm.mobile"
                  placeholder="请输入新手机号"
                />
              </el-form-item>
              <el-form-item prop="smsCode">
                <div class="flex">
                  <el-input
                    v-model.trim="phoneForm.smsCode"
                    placeholder="请输入验证码"
                    @keyup.enter.native="updateMobile"
                    @keydown.enter.native.prevent="() => {}"
                  />

                  <count-down-button
                    ref="countDown"
                    style="margin-left: 1rem"
                    :mobile="phoneForm.mobile"
                    :template-code="templateCodeObj.bindMobile"
                    @click.native="beforeVerify"
                    @getSmsToken="data => (phoneForm.smsToken = data.token)"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="updateMobile">
              确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CountDownButton from '@/components/CountDownButton'
import { templateCodeObj } from '@/dictionary'
import {
  searchIfMobileOccupiedApi,
  updateMobileApi,
  updateMobileVerifyApi
} from '@/api/user'
import { mapState } from 'vuex'

export default {
  name: 'ChangeMobile',

  components: {
    CountDownButton
  },

  data() {
    // 重新绑定手机号，检查是否与之前手机号相同
    const validateSamePhone = (rule, value, callback) => {
      if (value === this.userMobile) {
        callback(new Error('新手机号不能与当前手机号相同'))
      }

      if (value.length === 11) {
        searchIfMobileOccupiedApi({ mobile: value })
          .then(res => {
            if (res.data) {
              callback(new Error('当前手机号已被注册'))
              return
            } else {
              callback()
            }
          })
          .catch(err => {
            callback(new Error(err.data?.message))
          })
      }
    }

    return {
      // 数据字典
      templateCodeObj,

      // 修改绑定手机变量
      hasVerificationOldPhone: false, // 是否验证了旧手机号，如果验证了展示绑定新手机的弹窗
      phoneDialog: false,
      smsCodeForm: { smsCode: '', smsToken: '' },
      phoneForm: {
        mobile: '',
        smsCode: '',
        sign: '',
        smsToken: ''
      },
      smsCodeRules: {
        smsCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: ['blur', 'change']
          }
        ]
      },
      phoneRules: {
        smsCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: ['blur', 'change']
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^\d{11}$/,
            message: '请输入11位手机号',
            trigger: ['blur']
          },
          {
            validator: validateSamePhone,
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    ...mapState('user', ['userId', 'userMobile']),

    // 对手机号脱敏
    hideMobile() {
      if (this.userMobile) {
        return this.userMobile.slice(0, 3) + '****' + this.userMobile.slice(-4)
      } else {
        return this.userMobile
      }
    }
  },

  methods: {
    // 弹出图形验证码前，验证表单
    beforeVerify() {
      this.$refs.phoneForm.validateField('mobile', fail => {
        if (!fail) {
          this.$refs.countDown.showDialog()
        }
      })
    },

    // 验证旧手机号
    updateMobileVerify() {
      this.$refs.smsForm.validate(valid => {
        if (!valid) return

        updateMobileVerifyApi({
          userId: this.userId,
          mobile: this.userMobile,
          smsCode: this.smsCodeForm.smsCode,
          smsToken: this.smsCodeForm.smsToken
        })
          .then(res => {
            this.hasVerificationOldPhone = true
            this.phoneForm.sign = res.data.sign
          })
          .catch(err => {
            this.$message.error(err.data?.message)
          })
      })
    },

    // 上传新的手机号
    updateMobile() {
      this.$refs.phoneForm.validate(valid => {
        if (!valid) return

        updateMobileApi(this.phoneForm)
          .then(res => {
            this.phoneDialog = false
            // this.handleFunForMesChange('绑定手机号修改成功，请重新登录')
            this.$emit('afterChange', '绑定手机号修改成功，请重新登录')
          })
          .catch(err => {
            this.$message.error(err.data?.message)
          })
      })
    },

    // 关闭修改绑定手机号弹窗
    clearPhoneDialog() {
      this.phoneDialog = false
      this.smsCodeForm = { smsCode: '', smsToken: '' }
      this.phoneForm = {
        mobile: '',
        smsCode: '',
        sign: '',
        smsToken: ''
      }

      if (this.hasVerificationOldPhone) {
        this.$refs.phoneForm.resetFields()
      } else {
        this.$refs.smsForm.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mes-list {
  display: flex;
  align-items: center;
  margin-top: pixel-to-rem($n: 20);
  border-bottom: 1px solid $info-fourth-color;

  .list-left {
    flex: 1;
    text-align: left;

    p:first-child {
      font-size: 16px;
      margin: 10px 0;
    }
    p:last-child {
      color: $text-third-color;
    }
  }
}
</style>
